import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import BodyView from "@/layout/BodyView.vue"
// import AuthView from "@/components/common/block/auth/AuthView.vue"
// import LoginPage from "@/components/common/block/auth/LoginPage.vue"
// import indexDefault from "@/pages/dashbords/indexDefault.vue"
// import indexProject from "@/pages/dashbords/indexProject.vue"
// import indexEcommerce from "@/pages/dashbords/indexEcommerce.vue"
// import indexEducation from "@/pages/dashbords/indexEducation.vue"
// import indexGeneral from "@/pages/widgets/indexGeneral.vue"
// import indexChart from "@/pages/widgets/indexChart.vue"
// import indexProjectlist from "@/pages/project/indexProjectlist.vue"
// import indexCreateProject from "@/pages/project/indexCreateProject.vue"
// import indexFileManeger from "@/pages/filemaneger/indexFileManeger.vue"
// import indexKanbanBoard from "@/pages/kanban/indexKanbanBoard.vue"
// import indexAddProduct from "@/pages/ecommerce/indexAddProduct.vue"
// import indexProduct from "@/pages/ecommerce/indexProduct.vue"
// import indexCart from "@/pages/ecommerce/indexCart.vue"
// import indexProductPage from "@/pages/ecommerce/indexProductPage.vue"
// import indexCheckout from "@/pages/ecommerce/indexCheckout.vue"
// import indexPaymentDetail from "@/pages/ecommerce/indexPaymentDetail.vue"
// import indexOrder from "@/pages/ecommerce/indexOrder.vue"
// import indexWishlist from "@/pages/ecommerce/indexWishlist.vue"
// import indexPricing from "@/pages/ecommerce/indexPricing.vue"
// import indexInvoiceOne from "@/pages/ecommerce/indexInvoiceOne.vue"
// import indexProductList from "@/pages/ecommerce/indexProductList.vue"
// import indexInvoiceTwo from "@/pages/ecommerce/indexInvoiceTwo.vue"
// import indexInvoiceThree from "@/pages/ecommerce/indexInvoiceThree.vue"
// import indexInvoiceFour from "@/pages/ecommerce/indexInvoiceFour.vue"
// import indexInvoiceFive from "@/pages/ecommerce/indexInvoiceFive.vue"
// import indexInvoiceSix from "@/pages/ecommerce/indexInvoiceSix.vue"
// import indexLetterBox from "@/pages/letterbox/indexLetterBox.vue"
// import indexPrivateChat from "@/pages/chat/indexPrivateChat.vue"
// import indexGroupChat from "@/pages/chat/indexGroupChat.vue"
// import indexProfile from "@/pages/user/indexProfile.vue"
// import indexEdit from "@/pages/user/indexEdit.vue"
// import indexCard from "@/pages/user/indexCard.vue"
// import indexBookmark from "@/pages/bookmark/indexBookmark.vue"
// import indexContact from "@/pages/contacts/indexContact.vue"
// import indexTask from "@/pages/task/indexTask.vue"
// import indexCalendar from "@/pages/calendar/indexCalendar.vue"
// import indexSoical from "@/pages/socialapp/indexSoical.vue"
// import indexTodo from "@/pages/todo/indexTodo.vue"
// import indexSearch from "@/pages/search/indexSearch.vue"
// import indexValidation from "@/pages/forms/formcontrols/indexValidation.vue"
// import indexInputs from "@/pages/forms/formcontrols/indexInputs.vue"
// import indexCheckbox from "@/pages/forms/formcontrols/indexCheckbox.vue"
// import indexGroups from "@/pages/forms/formcontrols/indexGroups.vue"
// import indexMask from "@/pages/forms/formcontrols/indexMask.vue"
// import indexMega from "@/pages/forms/formcontrols/indexMega.vue"
// import indexDatapicker from "@/pages/forms/formwidgets/indexDatapicker.vue"
// import indexTouchspin from "@/pages/forms/formwidgets/indexTouchspin.vue"
// import indexSelect from "@/pages/forms/formwidgets/indexSelect.vue"
// import indexTypeahead from "@/pages/forms/formwidgets/indexTypeahead.vue"
// import indexClipboard from "@/pages/forms/formwidgets/indexClipboard.vue"
// import indexSwitch from "@/pages/forms/formwidgets/indexSwitch.vue"
// import formWizard from "@/pages/forms/formlayout/formWizard.vue"
// import formWizard2 from "@/pages/forms/formlayout/formWizard2.vue"
// import indexTwofactor from "@/pages/forms/formlayout/indexTwofactor.vue"
// import indexBootstrap from "@/pages/table/indexBootstrap.vue"
// import indexComponent from "@/pages/table/indexComponent.vue"
// import indexInit from "@/pages/table/indexInit.vue"
// import indexTypography from "@/pages/uikits/indexTypography.vue"
// import indexAvatars from "@/pages/uikits/indexAvatars.vue"
// import indexHelper from "@/pages/uikits/indexHelper.vue"
// import indexGrid from "@/pages/uikits/indexGrid.vue"
// import indexTagPills from "@/pages/uikits/indexTagPills.vue"
// import indexProgress from "@/pages/uikits/indexProgress.vue"
// import indexModal from "@/pages/uikits/indexModal.vue"
// import indexAlert from "@/pages/uikits/indexAlert.vue"
// import indexPopover from "@/pages/uikits/indexPopover.vue"
// import indexTooltip from "@/pages/uikits/indexTooltip.vue"
// import indexDropdown from "@/pages/uikits/indexDropdown.vue"
// import indexAccordion from "@/pages/uikits/indexAccordion.vue"
// import indexTabs from "@/pages/uikits/indexTabs.vue"
// import indexLists from "@/pages/uikits/indexLists.vue"
// import indexAnimate from "@/pages/animation/indexAnimate.vue"
// import indexAos from "@/pages/animation/indexAos.vue"
// import indexFlag from "@/pages/icons/indexFlag.vue"
// import indexFontawesome from "@/pages/icons/indexFontawesome.vue"
// import indexThemify from "@/pages/icons/indexThemify.vue"
// import indexIcoicon from "@/pages/icons/indexIcoicon.vue"
// import indexFeather from "@/pages/icons/indexFeather.vue"
// import indexWhether from "@/pages/icons/indexWhether.vue"
// import indexDefaultStyle from "@/pages/buttons/indexDefaultStyle.vue"
// import indexFlat from "@/pages/buttons/indexFlat.vue"
// import indexEdge from "@/pages/buttons/indexEdge.vue"
// import indexRaised from "@/pages/buttons/indexRaised.vue"
// import indexGroup from "@/pages/buttons/indexGroup.vue"
// import indexApexchart from "@/pages/charts/indexApexchart.vue"
// import indexGoogle from "@/pages/charts/indexGoogle.vue"
// import indexChartist from "@/pages/charts/indexChartist.vue"
// import indexSample from "@/pages/samplepage/indexSample.vue"
// import indexInternationalization from "@/pages/internationalization/indexInternationalization.vue"
// import indexErrorPage1 from "@/pages/error/indexErrorPage1.vue"
// import indexErrorPage2 from "@/pages/error/indexErrorPage2.vue"
// import indexErrorPage3 from "@/pages/error/indexErrorPage3.vue"
// import indexErrorPage4 from "@/pages/error/indexErrorPage4.vue"
// import indexErrorPage5 from "@/pages/error/indexErrorPage5.vue"
// import indexErrorPage6 from "@/pages/error/indexErrorPage6.vue"
// import indexComingsoonPage from "@/pages/comingsoon/indexComingsoonPage.vue"
// import indexComingsoonImage from "@/pages/comingsoon/indexComingsoonImage.vue"
// import indexComingsoonVideo from "@/pages/comingsoon/indexComingsoonVideo.vue"
// import loginSimple from "@/pages/authentication/loginSimple.vue"
// import loginImage from "@/pages/authentication/loginImage.vue"
// import loginImageTwo from "@/pages/authentication/loginImageTwo.vue"
// import loginValidation from "@/pages/authentication/loginValidation.vue"
// import loginTooltip from "@/pages/authentication/loginTooltip.vue"
// import loginSweetalert from "@/pages/authentication/loginSweetalert.vue"
// import registerSimple from "@/pages/authentication/registerSimple.vue"
// import registerImage from "@/pages/authentication/registerImage.vue"
// import registerImageTwo from "@/pages/authentication/registerImageTwo.vue"
// import unlockUser from "@/pages/authentication/unlockUser.vue"
// import forgetPassword from "@/pages/authentication/forgetPassword.vue"
// import resetPassword from "@/pages/authentication/resetPassword.vue"
// import maintenanceView from "@/pages/authentication/maintenanceView.vue"
// import indexGallery from "@/pages/gallery/indexGallery.vue"
// import indexGriddesc from "@/pages/gallery/indexGriddesc.vue"
// import indexMasonry from "@/pages/gallery/indexMasonry.vue"
// import indexMasonarydesc from "@/pages/gallery/indexMasonarydesc.vue"
// import indexHoverGallery from "@/pages/gallery/indexHoverGallery.vue"
// import indexDetails from "@/pages/blog/indexDetails.vue"
// import indexSingle from "@/pages/blog/indexSingle.vue"
// import indexAdd from "@/pages/blog/indexAdd.vue"
// import indexFaq from "@/pages/faq/indexFaq.vue"
// import indexJobCard from "@/pages/job/indexCard.vue"
// import indexList from "@/pages/job/indexList.vue"
// import indexJobDetails from "@/pages/job/indexDetails.vue"
// import indexApply from "@/pages/job/indexApply.vue"
// import indexLearning from "@/pages/learning/indexLearning.vue"
// import indexGoogleMap from "@/pages/maps/indexGoogle.vue"
// import indexCourse from "@/pages/learning/indexCourse.vue"
// import indexLeaflet from "@/pages/maps/indexLeaflet.vue"
// import indexCk from "@/pages/editor/indexCk.vue"
// import simpleEditor from "@/pages/editor/simpleEditor.vue"
// import indexKnowledgebase from "@/pages/knowledgebase/indexKnowledgebase.vue"
// import indexSupport from "@/pages/support/indexSupport.vue"
// import indexScrollable from "@/pages/advance/indexScrollable.vue"
// import indexTree from "@/pages/advance/indexTree.vue"
// import indexToasts from "@/pages/advance/indexToasts.vue"
// import indexRating from "@/pages/advance/indexRating.vue"
// import indexDropzone from "@/pages/advance/indexDropzone.vue"
// import indexTour from "@/pages/advance/indexTour.vue"
// import indexSweetalert from "@/pages/advance/indexSweetalert.vue"
// import animationModal from "@/pages/advance/animationModal.vue"
// import owlCarousel from "@/pages/advance/owlCarousel.vue"
// import indexCropper from "@/pages/advance/indexCropper.vue"

//elder
import main from '@/pages/elder/main.vue';
const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: "/elder/main"
  },

  {
    path: "/elder",
    component: BodyView,
    children: [
      {
        path: "main",
        name: "elder",
        component: main,
        meta: {
          title: 'elder',
        }
      }
    ]
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// router.beforeEach((to, from, next) => {
//   if (typeof (to.meta.title) === 'string') {
//     document.title = to.meta.title;
//   }
//   const path = ['/auth/login', '/auth/register'];
//   if (path.includes(to.path) || localStorage.getItem('user')) {
//     return next();
//   }
//   next('/auth/login');
// });

export default router
